import React from "react";
import { Check } from "lucide-react";

export default function WizardStepper({ steps, current, onGo }) {
  return (
    <div className="bg-white border border-border rounded p-5 sticky top-6">
      <div className="overline text-[9px] mb-4">Progress</div>
      <ol className="space-y-4">
        {steps.map((s, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <li key={s} className="flex items-start gap-3">
              <div className={`step-dot ${active ? "active" : ""} ${done ? "done" : ""}`}>
                {done ? <Check size={14} strokeWidth={2.4} /> : i + 1}
              </div>
              <button
                onClick={() => onGo(i)}
                data-testid={`step-${i}`}
                className={`text-left text-sm mt-1 ${
                  active ? "text-[#16A34A] font-semibold" : done ? "text-slate-700" : "text-slate-400"
                }`}
              >
                {s}
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
